import {
  faStackOverflow,
  faLinkedin,
  faGithub,
} from "@fortawesome/free-brands-svg-icons";
import { faPaperPlane } from "@fortawesome/free-regular-svg-icons";
import { faIcons } from "@fortawesome/free-solid-svg-icons";

export const icons = {
  StackOverflow: faStackOverflow,
  faPaperPlane: faPaperPlane,
  Github: faGithub,
  Linkedin: faLinkedin,
};
